import Fnc from 'usefull-functions';
import RecursiveDemo from './RecursiveDemo.vue';

export default {
	name: "DivisibilityRules",
	props: {
		terms: {type: [Array, Object], required: true},
		deep: { default: 0 }
	},
	components: { RecursiveDemo },
	data() {
		let terms = this.terms.sort((a, b) => b - a);
		return {
			divider: terms[1],
			divident: terms[0],
			showRecursive: false
		}
	},
	computed: {
		endDivident() {
			return this.divider.toString().slice(-1);
		},
		result() {
			return this.divident % this.divider == 0;
		},
		readDivident() {
			return this.read_notation(this.divident);
		},
		readDivider() {
			return this.read_notation(this.divider);
		},
		key_result() {
			return `${this.result ? '' : 'not '}`;
		},
		conclusion() {
			let str = '', key_result = `${this.result ? '' : 'not '}`;
			switch (Number(this.divider)) {
				case 2:
					str = `Since the number ends in ${this.lastDigit}, it implies that the number is ${key_result}divisible by 2.`;
					return str;
					break;
				case 3:
					str = `Since the sum of the digits is ${key_result}divisible by ${this.readDivider} , it implies that ${this.readDivident} is ${key_result}divisible by ${this.readDivider}`;
					return str;;
					break;
				case 4:
					let digits_rule = this.divident.toString().slice(-2);
					str = `Since the last two digits (${digits_rule}) is ${key_result}divisible by 4, it implies that the <span class="text-danger">number (${this.readDivident}) is ${key_result}divisible by 4</span>`;
					return str;
					break;
				case 5:
					str = `Since the last digit is ${this.lastDigit}, it implies that ${this.readDivident} is ${key_result}divisible by 5`;
					return str;
					break;
				case 6:
					str = `You see that, ${this.readDivident} is ${ key_result }divisible by both 2 and 3`;
					break;
				case 7:
					str = `You see that the new number (${this.subtractedDoubleLastDigitFromExceptLastDigit}) is ${key_result}divisible by 7`;
					return str;
					break;
				case 8:
					str = `Since last three digits (${this.last3Digits}) is ${key_result}divisible by 8, it implies that ${this.readDivident} is ${key_result}divisible by 8`;
					return str;
					break;
				case 9:
					str = `Since the sum of the digits is ${key_result}divisible by ${this.readDivider} , it implies that ${this.readDivident} is ${key_result}divisible by ${this.readDivider}`;
					return str;
					break;
				case 10:
					str = `Since the last digit of the number is ${key_result}0, it implies that ${this.readDivident} is ${key_result}divisible by 10`;
					return str;
					break;
				case 11:
					str = `Since the new number (${this.subtractedLastDigitFromExceptLastDigit}) is ${key_result}divisible by ${this.divider} it implies that ${this.readDivident} is ${key_result}divisible by ${this.divider}`;
					return str;
					break;
				case 12:
					str = `You see that, ${this.readDivident} is ${ key_result }divisible by both 3 and 4`;
					break;
				default:
					// statements_def
					break;
			}
			return str;
		},
		sumDigitStr() {
			return this.divident.toString().replace('.', '').split('').join(' + ') + ' = ' + this.sumDigit;
		},
		sumDigit() {
			return this.divident.toString().replace('.', '').split('').map(Number).reduce((a, b) => a + b, 0);
		},
		divisionSumStr() {
			return `${this.sumDigit} ÷ ${this.divider} = ${parseInt(this.sumDigit / this.divider)} ${this.result ? '' : (' remainder ' + this.sumDigit % this.divider)}`;
		},
		divisionStr() {
			return `${this.readDivident} ÷ ${this.readDivider} = ${this.dividend / this.divider}`;
		},
		lastDigit() {
			return this.divident.toString().slice(-1);
		},
		doubleLastDigitStr() {
			return `${this.lastDigit} + ${this.lastDigit} = ${this.doubleLastDigit}`;
		},
		doubleLastDigit() {
			return Number(this.lastDigit) + Number(this.lastDigit);
		},
		subtractedDoubleLastDigitFromExceptLastDigit() {
			return Number(this.divident.toString().slice(0, -1)) - this.doubleLastDigit;
		},
		subtractDoubleLastDigitFromExceptLastDigitStr() {
			return `${this.readDivident.toString().slice(0, -1)} - ${this.doubleLastDigit} = ${this.subtractedDoubleLastDigitFromExceptLastDigit}`;
		},
		subtractedDoubleLastDigitFromExceptLastDigitDivisionStr() {
			return `${this.read_notation(this.subtractedDoubleLastDigitFromExceptLastDigit)} ÷ ${this.divider} = ${parseInt(this.subtractedDoubleLastDigitFromExceptLastDigit / this.divider)} ${this.result ? '' : ('remainder ' + this.subtractedDoubleLastDigitFromExceptLastDigit % this.divider)}`
		},
		subtractedLastDigitFromExceptLastDigit() {
			return Number(this.divident.toString().slice(0, -1)) - this.lastDigit;
		},
		subtractLastDigitFromExceptLastDigitStr() {
			return `${this.readDivident.toString().slice(0, -1)}(new number formed) - ${this.lastDigit}(last digit) = ${this.subtractedLastDigitFromExceptLastDigit}`;
		},
		subtractedLastDigitFromExceptLastDigitDivisionStr() {
			return `${this.read_notation(this.subtractedLastDigitFromExceptLastDigit)} ÷ ${this.divider} = ${parseInt(this.subtractedLastDigitFromExceptLastDigit / this.divider)} ${this.result ? '' : ('remainder ' + this.subtractedLastDigitFromExceptLastDigit % this.divider)}`
		},
		sumDigitDivisionStr() {
			return `${this.sumDigit} ÷ ${this.divider} = ${this.quotient} ${this.result ? '' : ('remainder ' + this.remainder)}`
		},
		quotient() {
			return this.read_notation(parseInt(this.divident / this.divider));
		},
		remainder() {
			return this.divident % this.diviser;
		},
		last3Digits() {
			return this.last_n_Digits_(3);
		},
		last3DigitsRed() {
			return this.last_n_DigitsRed_(3)
		},
		last2Digits() {
			return this.last_n_Digits_(2);
		},
		last2DigitsRed() {
			return this.last_n_DigitsRed_(2)
		},
		isRecursive() {
			switch (Number(this.divider)) {
				case 3: return this.sumDigit > 10; break;
				case 6: return this.sumDigit > 10; break;
				case 9: return this.sumDigit > 10; break;
				case 7: return this.subtractedDoubleLastDigitFromExceptLastDigit > 70; break;
				case 11: return this.subtractedLastDigitFromExceptLastDigit > 99; break;
				case 12: return this.sumDigit > 36;
				default:
					return false;
					break;
			}
		},
		recursiveText() {
			return this.showRecursive ? ("Show less" + Fnc.tag('i', '', {class: 'fa fa-angle-double-left ml-2 fa-2x', style: 'vertical-align: middle'})) : ("Show more" + Fnc.tag('i', '', {class: 'fa fa-angle-double-right ml-2 fa-2x', style: 'vertical-align: middle'}))
		}
	},
	methods: {
		sumDigit_(divident = this.divident) {
			return divident.toString().replace('.', '').split('').map(Number).reduce((a, b) => a + b, 0);
		},
		quotient_(divident = this.divident, divider = this.divider) {
			return parseInt(divident / divider);
		},
		sumDigitDivisionStr_(divider, divident = this.divident) {
			let sumDigit = this.sumDigit_(divident), quotient = this.quotient_(sumDigit, divider), remainder = divident % divider;
			return `${sumDigit} ÷ ${divider} = ${quotient} ${remainder == 0 ? '' : ('remainder ' + remainder)}`;
		},
		last_n_DigitsRed_(n, divident = this.divident) {
			let p = Math.pow(10, n);
			return parseInt(divident / p).toString() + Fnc.tag('span', (divident % p), {class: 'text-danger'});
			/*
			let read = this.read_notation(divident).split(','), index = read.length - 1, digits = read[index];
			read[index] = ;
			return read.join(',');*/
		},
		last_n_Digits_(n, divident = this.divident) {
			return this.divident.slice(-n);
		}
	}
}